<template>
  <div>
    <vs-popup
      fullscreen
      title="Gestion documentaire"
      :active.sync="isPopupFilesActiveLocal"
    >
      <vx-card class="mb-4">
        <vue-dropzone
          ref="imgDropZone"
          id="customdropzone"
          :options="dropzoneOptions"
          @vdropzone-complete="afterComplete"
        ></vue-dropzone>
      </vx-card>
      <vx-card v-if="childList.length == 0" style="display:flex; width:100%">
        <div
          style="display:flex;align-items: center; justify-content: space-between"
        >
          <div style="display:flex;align-items: center">
            <vs-button
              v-if="this.actualFolder != null"
              @click="backToLastFolder()"
              radius
              class="mr-2"
              type="border"
              icon-pack="feather"
              icon="icon-arrow-left"
            ></vs-button>
            <h3 class="mr-2 ml-2" style="display:flex;align-items:center">
              Dossiers
            </h3>
          </div>
        </div>
        <div style="display:flex">
          <div
            v-for="(itemFolder, indexFolder) in childListFolder"
            :key="indexFolder"
            @click="documentRouter(itemFolder)"
            class="div-open-folder"
          >
            <vx-tooltip :text="itemFolder.caption" class="content-div-folder">
              <div
                class="m-2 img-folder"
                style="max-height: 100px;border-radius: 5px; "
                :style="bgFolderImg(itemFolder.src)"
              ></div>
              <p class="caption-folder">{{ itemFolder.caption }}</p>
            </vx-tooltip>
          </div>
        </div>
        <vs-divider></vs-divider>
        <div style="display:flex;justify-content:center">
          <p>Aucun élément dans ce dossier</p>
        </div>
      </vx-card>
      <vx-card v-else style="display:flex; width:100%; height:100%">
        <div
          style="display:flex;align-items: center; justify-content: space-between"
        >
          <div style="display:flex;align-items: center">
            <vs-button
              v-if="this.actualFolder != null"
              @click="backToLastFolder()"
              radius
              class="mr-2"
              type="border"
              icon-pack="feather"
              icon="icon-arrow-left"
            ></vs-button>
            <h3 class="mr-2 ml-2 " style="display:flex;align-items:center">
              Dossiers
            </h3>
          </div>
        </div>
        <div style="display:flex">
          <div
            v-for="(itemFolder, indexFolder) in childListFolder"
            :key="indexFolder"
            @click="documentRouter(itemFolder)"
            class="div-open-folder"
          >
            <vx-tooltip :text="itemFolder.caption" class="content-div-folder">
              <div
                class="m-2 img-folder"
                style="max-height: 100px;border-radius: 5px; "
                :style="bgFolderImg(itemFolder.src)"
              ></div>
              <p class="caption-folder">{{ itemFolder.caption }}</p>
            </vx-tooltip>
          </div>
        </div>
        <vs-divider></vs-divider>
        <div style="width:100%" class="container-pictures">
          <h3>Fichiers</h3>
          <div
            class="flex flex-wrap"
            style="margin-left:-1rem; margin-right:-1rem"
          >
            <div
              style="position:relative; text-align: -webkit-center; width:200px"
              v-for="(item, index) in childList"
              :key="index"
            >
              <div class="file-container">
                <div class="file-hover">
                  <div class="file-img m-0 p-2">
                    <div
                      @click="emitSrc(item.download)"
                      class="m-0 p-0 enableBlur"
                      style="max-height: 190px;"
                      :style="bgImage(item.src != null ? item.src : item.thumb)"
                    ></div>
                  </div>
                  <div class="file-text m-0 p-2 text-center">
                    <span>{{ item.caption }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </vs-popup>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { setSubCollection } from "@/../script/global";
let uuid = require("uuid");
require("vue-it-bigger/dist/vue-it-bigger.min.css");

// FIREBASE
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
var db = firebase.firestore();

export default {
  props: {
    activePopupFiles: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        addRemoveLinks: false,
        dictDefaultMessage: `<i class='fa fa-cloud-upload'></i><p class='text-default'>Faites glisser vos images ou cliquez ici</p>`,
      },
      dataElement: {
        parent: [],
        addDate: new Date(),
        caption: null,
        deleteDate: null,
        id: null,
        src: null,
        thumb: null,
        download: null,
        updateDate: new Date(),
        format: "file",
        hover: false,
      },
      actualFolder: "all",
      childList: [],
      childListFolder: [],
      allList: [],
    };
  },
  created() {
    db.collection("customers")
      .doc(this.$route.params.id)
      .collection("storage")
      .onSnapshot((snap) => {
        let fooFolder = [];
        let fooFile = [];
        let fooAll = [];
        snap.forEach((doc) => {
          if (doc.data().deleteDate == null) {
            fooAll.push(doc.data());
            if (
              doc.data().format == "folder" &&
              doc.data().parent.includes("root")
            ) {
              fooFolder.push(doc.data());
            } else if (
              doc.data().format == "file" &&
              doc.data().parent.includes("root")
            ) {
              fooFile.push(doc.data());
            }
          }
        });
        this.childListFolder = fooFolder;
        this.childList = fooFile;
        this.allList = fooAll;
      });
  },
  computed: {
    isPopupFilesActiveLocal: {
      get() {
        return this.activePopupFiles;
      },
      set(val) {
        if (!val) {
          this.$emit("closePopupFiles");
        }
      },
    },
  },
  methods: {
    documentRouter(dataItem) {
      this.actualFolder = dataItem;
      for (let i = 0; i < this.allList.length; i++) {
        const element = this.allList[i];
        if (
          element.caption == dataItem.caption &&
          element.parent[0] == dataItem.parent[0]
        ) {
          this.childList = [];
          this.childListFolder = [];
          this.allList.forEach((elementAllList) => {
            if (
              elementAllList.format == "folder" &&
              elementAllList.parent[0] == element.id
            ) {
              this.childListFolder.push(elementAllList);
            } else if (
              elementAllList.format == "file" &&
              elementAllList.parent[0] == element.id
            ) {
              this.childList.push(elementAllList);
            }
          });
          break;
        }
      }
    },
    backToLastFolder() {
      let check = false;
      for (let i = 0; i < this.allList.length; i++) {
        const element = this.allList[i];
        if (element.id == this.actualFolder.parent[0]) {
          check = true;
          this.actualFolder = element;
          this.childList = [];
          this.childListFolder = [];
          this.allList.forEach((elementAllList) => {
            if (
              elementAllList.format == "folder" &&
              elementAllList.parent[0] == element.id
            ) {
              this.childListFolder.push(elementAllList);
            } else if (
              elementAllList.format == "file" &&
              elementAllList.parent[0] == element.id
            ) {
              this.childList.push(elementAllList);
            }
          });
        }
      }
      if (check == false) {
        this.actualFolder = "all";
        this.childList = [];
        this.childListFolder = [];
        this.allList.forEach((elementAllList) => {
          if (
            elementAllList.format == "folder" &&
            elementAllList.parent.includes("root")
          ) {
            this.childListFolder.push(elementAllList);
          } else if (
            elementAllList.format == "file" &&
            elementAllList.parent.includes("root")
          ) {
            this.childList.push(elementAllList);
          }
        });
      }
    },
    bgImage(img) {
      return (
        "background-image:url(" +
        img +
        "); background-position: center; background-size: contain;height: 150px;width:150px; background-repeat: no-repeat; "
      );
    },
    bgFolderImg(img) {
      return (
        "background-image:url(" +
        img +
        "); background-position: center; background-size: contain;height: 30px;width:30px; background-repeat: no-repeat; "
      );
    },
    async afterComplete(upload) {
      var imageName = uuid.v1();
      this.isLoading = true;
      this.dataElement.parent = [];
      try {
        let file = upload;
        var metadata = {};
        var storageRef = firebase.storage().ref();
        if (this.actualFolder == "all") {
          var imageRef = storageRef.child(
            `${this.$route.params.id}/${imageName}`
          );
        } else {
          var imageRef = storageRef.child(
            `${this.$route.params.id}/${this.actualFolder.id}/${imageName}`
          );
        }
        await imageRef.put(file, metadata);
        if (this.actualFolder == "all") {
          this.dataElement.parent.push("root");
        } else {
          this.dataElement.parent.push(this.actualFolder.id);
        }
        this.dataElement.caption = file.upload.filename;
        if (file.type.includes("rtf")) {
          this.dataElement.src = this.dataElement.thumb =
            "https://firebasestorage.googleapis.com/v0/b/web-app-43811.appspot.com/o/rtf.png?alt=media&token=0ecdd305-fa6e-4267-bb99-958d594cb2d6";
          this.dataElement.download = await imageRef.getDownloadURL();
        } else if (file.type.includes("pdf")) {
          this.dataElement.src = this.dataElement.thumb =
            "https://firebasestorage.googleapis.com/v0/b/web-app-43811.appspot.com/o/pdf.png?alt=media&token=919c027f-70ca-465f-aff8-766e088b7b6b";
          this.dataElement.download = await imageRef.getDownloadURL();
        } else if (file.type.includes("xls")) {
          this.dataElement.src = this.dataElement.thumb =
            "https://firebasestorage.googleapis.com/v0/b/web-app-43811.appspot.com/o/xls.png?alt=media&token=8afc38d6-d072-487c-9e4b-b73583a16dec";
          this.dataElement.download = await imageRef.getDownloadURL();
        } else if (file.type.includes("xlsx")) {
          this.dataElement.src = this.dataElement.thumb =
            "https://firebasestorage.googleapis.com/v0/b/web-app-43811.appspot.com/o/xlsx.png?alt=media&token=51500c92-0279-4c5c-aece-e706135766be";
          this.dataElement.download = await imageRef.getDownloadURL();
        } else if (file.type.includes("doc")) {
          this.dataElement.src = this.dataElement.thumb =
            "https://firebasestorage.googleapis.com/v0/b/web-app-43811.appspot.com/o/doc.png?alt=media&token=d9738864-93d1-45fa-b8ad-d5c378e9b63a";
          this.dataElement.download = await imageRef.getDownloadURL();
        } else if (file.type.includes("docx")) {
          this.dataElement.src = this.dataElement.thumb =
            "https://firebasestorage.googleapis.com/v0/b/web-app-43811.appspot.com/o/docx.png?alt=media&token=7618c5d8-a1d7-4b54-8adb-d2b291b60ffb";
          this.dataElement.download = await imageRef.getDownloadURL();
        } else if (file.type.includes("pages")) {
          this.dataElement.src = this.dataElement.thumb =
            "https://firebasestorage.googleapis.com/v0/b/web-app-43811.appspot.com/o/pages.png?alt=media&token=0fe4cf4c-e2c5-48b8-b289-2ce71f4ef9d2";
          this.dataElement.download = await imageRef.getDownloadURL();
        } else if (file.type.includes("xml")) {
          this.dataElement.src = this.dataElement.thumb =
            "https://firebasestorage.googleapis.com/v0/b/web-app-43811.appspot.com/o/xml.png?alt=media&token=1393b3ad-01da-41e0-ac42-04cd692d5d7c";
          this.dataElement.download = await imageRef.getDownloadURL();
        } else if (file.type.includes("video")) {
          this.dataElement.thumb =
            "https://firebasestorage.googleapis.com/v0/b/web-app-43811.appspot.com/o/mp4.png?alt=media&token=fd2d0294-12e4-45ce-bbc2-ce1b16ea5c43";
          this.dataElement.sources = [
            {
              src: null,
              type: null,
            },
          ];
          this.dataElement.format = "file";
          this.dataElement.sources[0].src = this.dataElement.download = await imageRef.getDownloadURL();
          this.dataElement.sources[0].type = file.type;
          this.dataElement.type = "video";
          this.dataElement.width = 800;
          this.dataElement.height = 600;
          this.dataElement.autoplay = false;
        } else {
          this.dataElement.src = this.dataElement.thumb = this.dataElement.download = await imageRef.getDownloadURL();
        }
        setSubCollection(
          "customers",
          "storage",
          this.dataElement,
          this.$route.params.id
        );
      } catch (error) {
        console.error(error);
      }
      this.$refs.imgDropZone.removeFile(upload);
    },
    emitSrc(imageSrc) {
      this.$emit("imageSrc", imageSrc);
      this.isPopupFilesActiveLocal = false;
    },
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
};
</script>

<style>
.container-pictures .vx-card__body {
  display: flex;
  width: 100%;
}

.div-open-folder {
  cursor: pointer;
  display: flex;
  width: 200px;
  height: 50px;
  justify-content: space-between;
  align-items: center;
  border: solid 2px #e5e5e5;
  border-radius: 5px;
  padding: 10px;
  margin: 15px 15px 15px 0px;
  margin-top: 15px;
  overflow: hidden;
}

.content-div-folder {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.caption-folder {
  overflow: hidden;
  max-width: 130px;
  overflow-wrap: normal;
  max-height: 100%;
  white-space: nowrap;
}

.vx-card .vx-card__collapsible-content.vs-con-loading__container {
  width: 100%;
}

.file-container {
  padding: 1rem;
}

.file-hover {
  cursor: pointer;
  border: 1px solid #dadce0;
  position: relative;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

.file-img {
  border-bottom: 1px solid #dadce0;
}

.file-img div {
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

.file-tools {
  filter: blur(0px);
  position: absolute;
  top: 30%;
  z-index: 1000000;
  display: flex;
  flex-direction: column;
}

@import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");
</style>
